<template>
  <div :class="['my_tag', `${type}_color`, reverse && 'reverse']">
    {{ value }}
    <slot></slot>
  </div>
</template>
<script>
export default {
  props: {
    value: Array,
    type: {
      type: String,
      default: "success",
    },
    reverse: Boolean,
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.my_tag {
  display: inline-block;
  padding: 2px 10px;
  background: #fff;
  border-radius: 1em;
  font-size: 14px;
}
.success_color {
  color: #13A07B;
}
.success_color.reverse {
  background: #13A07B;
  color: #fff;
}
.warning_color {
  color: #FFC107;
}
.warning_color.reverse {
  background: #FFC107;
  color: #fff;
}
.danger_color {
  color: #F33B40;
}
.danger_color.reverse {
  background: #F33B40;
  color: #fff;
}
.fail_color {
  color: #F48766;
}
.fail_color.reverse {
  background: #F48766;
  color: #fff;
}
.link_color {
  color: #299AC5;
}
.link_color.reverse {
  background: #299AC5;
  color: #fff;
}
.disable_color {
  color: #FAFAFA;
  background: #B5B5B5;
}
.disable_color.reverse {
  background: #FAFAFA;
  color: #B5B5B5;
}
</style>
